import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["status", "playlistId", "playlistItem", "position"];
import { useUserOwnsPlaylist } from '../../savedItems/savedItemsQueries';
import styled, { css, mediaQuery, theme, useMediaQuery } from 'academy-common-lib/utils/Styling';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIIcon from 'UIComponents/icon/UIIcon';
import { RoundelIcon } from '../../../components/Icons/RoundelIcon';
import { AddRemoveFromPlaylistButtonUnstyled, usePlaylistItemManager } from './PlaylistItemManager';
import ReducedContentCard from '../../../components/ContentCards/ReducedContentCard/ReducedContentCard';
import UIBox from 'UIComponents/layout/UIBox';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const LIST_ID = 'PLAYLIST_ITEM_LIST';
const SQUARE_DIMENSION_MOBILE = 60;
const SQUARE_DIMENSION = 100;
export const PlaylistDragProvider = ({
  children
}) => {
  const {
    movePlaylistItem
  } = usePlaylistItemManager();
  const onDragEnd = result => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    // dropped in the same position
    if (result.destination.index === result.source.index) {
      return;
    }
    movePlaylistItem(result.source.index, result.destination.index);
  };
  return /*#__PURE__*/_jsx(DragDropContext, {
    onDragEnd: onDragEnd,
    children: /*#__PURE__*/_jsx(Droppable, {
      droppableId: LIST_ID,
      children: dropProvided => /*#__PURE__*/_jsxs("div", {
        ref: dropProvided.innerRef,
        children: [children, dropProvided.placeholder]
      })
    })
  });
};
const ProgressIndicatorImpl = ({
  className,
  status
}) => {
  return /*#__PURE__*/_jsx("div", {
    className: className,
    children: /*#__PURE__*/_jsx(RoundelIcon, {
      backgroundColor: status === 'COMPLETED' ? theme.colors.LORAX : theme.colors.OLAF,
      borderColor: status === 'NOT_STARTED' ? theme.colors.BATTLESHIP : status === 'IN_PROGRESS' ? theme.colors.LORAX : status === 'COMPLETED' && theme.colors.LORAX || theme.colors.OLAF,
      name: 'success'
    })
  });
};
const ProgressIndicator = styled(ProgressIndicatorImpl).attrs({
  className: 'playlist-progress-indicator'
}).withConfig({
  displayName: "PlaylistItem__ProgressIndicator",
  componentId: "sc-2boyxr-0"
})(["height:76px;", " border:1px solid ", ";margin-left:8px;margin-right:24px;position:relative;&& > span{position:absolute;top:-1px;left:-10px;}"], mediaQuery('notMobile', css(["height:120px;"])), theme.colors.BATTLESHIP);
export const AddRemoveFromPlaylistButton = styled(AddRemoveFromPlaylistButtonUnstyled).withConfig({
  displayName: "PlaylistItem__AddRemoveFromPlaylistButton",
  componentId: "sc-2boyxr-1"
})(["position:absolute;top:0;width:", "px;height:", "px;", " && > span{position:absolute;top:5px;right:5px;}"], SQUARE_DIMENSION, SQUARE_DIMENSION, mediaQuery('mobile', css(["width:", "px;height:", "px;"], SQUARE_DIMENSION_MOBILE, SQUARE_DIMENSION_MOBILE)));
export const PlaylistItem = _ref => {
  let {
      status,
      playlistId,
      playlistItem,
      position
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    isMobile
  } = useMediaQuery();
  const userOwnsPlaylist = useUserOwnsPlaylist(playlistId);
  const dragId = `${playlistItem.itemId}-${playlistItem.type}`;
  return /*#__PURE__*/_jsx(Draggable, {
    draggableId: dragId,
    index: position,
    children: dragProvided => /*#__PURE__*/_jsxs(UIFlex, Object.assign({
      ref: dragProvided.innerRef,
      style: Object.assign({
        opacity: playlistItem.hasBeenRemoved ? 0.3 : 1
      }, dragProvided.draggableProps.style)
    }, props, dragProvided.draggableProps, dragProvided.dragHandleProps, {
      children: [/*#__PURE__*/_jsx(ProgressIndicator, {
        status: status
      }), userOwnsPlaylist && /*#__PURE__*/_jsx(UIFlex, {
        className: "m-right-3",
        direction: "column",
        justify: "center",
        style: {
          height: isMobile ? SQUARE_DIMENSION_MOBILE : SQUARE_DIMENSION,
          flex: 0,
          cursor: 'move'
        },
        children: /*#__PURE__*/_jsx(UIIcon, {
          color: theme.colors.SLINKY,
          name: "dragHandle",
          size: "xxs"
        })
      }), /*#__PURE__*/_jsx(UIBox, {
        grow: 1,
        children: /*#__PURE__*/_jsx(ReducedContentCard, {
          appearsIn: "playlist",
          contentId: playlistItem.itemId,
          contentType: playlistItem.type === 'SHORT_FORM_CONTENT' ? 'short' : playlistItem.type === 'TRACK' ? 'track' : 'lesson',
          customAction: /*#__PURE__*/_jsx(AddRemoveFromPlaylistButton, {
            iconSize: "sm",
            playlistItem: playlistItem
          }),
          language: playlistItem.language,
          overviewType: "playlist",
          playlistId: playlistId,
          position: position,
          size: isMobile ? 'small' : 'medium'
        })
      })]
    }))
  }, dragId);
};